export const ADDRESS_CONFIRMATION_MODAL = 'addressConfirmation'
